export default {
	video: 'video',
	img: 'image',
	doc: 'document',
	audio: 'audio',
	text: 'text',
};
